import { render, staticRenderFns } from "./score-history-item.vue?vue&type=template&id=63643932&scoped=true"
import script from "./score-history-item.vue?vue&type=script&lang=js"
export * from "./score-history-item.vue?vue&type=script&lang=js"
import style0 from "./score-history-item.vue?vue&type=style&index=0&id=63643932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63643932",
  null
  
)

export default component.exports